<script setup>
import {Permissions} from "@/Utils/Permissions";
import BulkAssignComponent from "@/Components/Claims/BulkAssignComponent.vue";
import {useRoute} from "vue-router";
const route = useRoute();
</script>

<template>
  <v-row v-if="Permissions.checkPermissions(['claims.bulk-assign'])" >
    <v-col cols="12">
      <BulkAssignComponent :contextIdA="route.params.id"/>
    </v-col>
  </v-row>
</template>

<style scoped>

</style>